/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { PlaylistField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedPlaylistModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    onSubmit={({ playlist }) => onSubmit(playlist)}
    title="Add related playlist"
    okText="ADD PLAYLIST"
    visible={visible}
    hide={hide}
  >
    <PlaylistField
      rules={[{ required: true, message: 'Playlist is required' }]}
      label="Choose a playlist"
      style={NO_MARGIN_BOTTOM}
      name="playlist"
    />
  </RelatedContentModal>
);

const Item = (playlist) => <InfoItem>{playlist.title}</InfoItem>;

RelatedPlaylistModal.Item = Item;

export default RelatedPlaylistModal;
